<template>
  <v-app>
    <v-container>
      <v-row>
        <v-col>
          <label>Специальность</label>
          <select id="edu_prog"
                  @change="getInfo(prog)"
                  class="ui fluid search selection dropdown fullText"
                  name="edu_prog"
                  v-model="prog">
            <option value="">Выберите специальность</option>
            <option v-for="option in edu_progs" :value="option.id" :key="option.id">
              {{ option.name }}
            </option>
          </select>
        </v-col>
        <v-col align-self="end" cols="2">
          <v-btn class="green" v-on:click="reset()">
            Сбросить
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-btn class="green" v-on:click="getTable()">
      <i class="file pdf outline icon"></i>
      Выгрузить
    </v-btn>
    <v-card
        elevation="13"
    >
      <v-card-title>Общая удовлетворенность:   <pre style="color:red;">    {{satisfaction}}</pre></v-card-title>
    </v-card>
    <table id="main" class="ui basic celled table">
      <tbody v-for="question in countAnswers">
        <tr>
          <td colspan="2"><b>{{ question.option }}<pre style="color:red;">{{question.satis}}</pre></b></td>
        </tr>
        <tr v-for="res in question.result">
          <td>{{ res.option }}</td>
          <td>{{ res.count }}</td>
        </tr>
      </tbody>


    </table>
  </v-app>
</template>

<script>

import axios from "axios";
import _ from 'lodash';
import TableExport from 'tableexport';

export default {
  name: "Results",
  data() {
    return {
      questions: [],
      answers: [],
      edu_progs: [],
      satisfaction: 0,
      prog: 0,
      prog_name: "АмГУ",
    }
  },
  computed:{
    countAnswers(){
      let result = []
      let sat = []
      this.questions.forEach(question =>{
        let positive = 0
        let options = []
        if (question.type === "radiogroup"){
          question.choices.forEach(option =>{
            let answers = _.filter(this.answers, function(o){
              if (o[question.name] === option)
                return o
            })
            options.push({option: option, count:  answers.length})
            if (['оченьнравится', 'да,соответствует', 'полностьюприменимы', 'отлично', 'да', 'да,удовлетворен', 'да,полностьюсогласен'].includes(option.replaceAll(" ","").toLowerCase())) {
              positive += answers.length * 5
            }
            else if (['вцеломнравится,нохочетсябольшего', 'скореесоответствует', 'скорееприменимы', 'хорошо', 'скорееда', 'скорееудовлетворен', 'скореесогласен'].includes(option.replaceAll(" ","").toLowerCase())) {
              positive += answers.length * 4
            }
            else if (['затрудняюсьответить', 'неприходилосьобщаться'].includes(option.replaceAll(" ","").toLowerCase())) {
              positive += answers.length * 3
            }
            else if (['вцеломненравится,хотяестьиположительныемоменты', 'скореенесоответствует', 'скореенеприменимы', 'плохо', 'скореенет', 'скореенеудовлетворен', 'скореенесогласен'].includes(option.replaceAll(" ","").toLowerCase())) {
              positive += answers.length * 2
            }
            else {
              positive += answers.length * 1
            }
          })
          sat.push(parseFloat((positive/this.answers.length).toFixed(2)))
        }
        if (question.type === "rating"){

          let av = 0
          this.answers.forEach(a =>{
            av += a[question.name]
          })
          options.push({option: "СР.знач", count:  (av/this.answers.length).toFixed(2)})
          sat.push(parseFloat((av/this.answers.length).toFixed(2)))
        }
        result.push({option: question.name, result: options, satis: (positive/this.answers.length).toFixed(2)})
      })
      this.satisfaction = _.mean(sat)
      return result
    }
  },
  methods: {
    getInfo(id){
      if (id !== 0) {
        axios({
          method: 'get',
          url: `results/${id}.json`,
        }).then((response) => {
          this.questions = JSON.parse(response.data.questionnaire);
          this.questions = this.questions.pages[0].elements;
          this.answers = response.data.answers;
          this.jsonAnswers();
          this.prog_name = _.find(this.edu_progs, ['id', this.prog]).name

        }).catch((error) => {
          return error;
        });
      }
      else {
        axios({
          method: 'get',
          url: `results.json`,
        }).then((response) => {
          this.questions = JSON.parse(response.data.questionnaire);
          this.questions = this.questions.pages[0].elements;
          this.answers = response.data.answers;
          this.jsonAnswers();
          this.prog_name = 'АмГУ'
        }).catch((error) => {
          return error;
        });
      }
    },
    jsonAnswers(){
      let json_answers = []
      this.answers.forEach(el=>{
          json_answers.push(JSON.parse(el))
      })
      this.answers = json_answers
    },
    getTable(){
      let table = TableExport(document.getElementById("main"), {
        headers: true,                      // (Boolean), display table headers (th or td elements) in the <thead>, (default: true)
        footers: true,                      // (Boolean), display table footers (th or td elements) in the <tfoot>, (default: false)
        formats: ["xlsx"],    // (String[]), filetype(s) for the export, (default: ['xlsx', 'csv', 'txt'])
        filename: `${this.prog_name.slice(0,9)}`,                     // (id, String), filename for the downloaded file, (default: 'id')
        bootstrap: false,                   // (Boolean), style buttons using bootstrap, (default: true)
        exportButtons: true,                // (Boolean), automatically generate the built-in export buttons for each of the specified formats (default: true)
        position: "top",                 // (top, bottom), position of the caption element relative to table, (default: 'bottom')
        ignoreRows: null,                   // (Number, Number[]), row indices to exclude from the exported file(s) (default: null)
        ignoreCols: null,                   // (Number, Number[]), column indices to exclude from the exported file(s) (default: null)
        trimWhitespace: true,               // (Boolean), remove all leading/trailing newlines, spaces, and tabs from cell text in the exported file(s) (default: false)
        RTL: false,                         // (Boolean), set direction of the worksheet to right-to-left (default: false)
        sheetname: `${this.prog_name.slice(0,9)}`                    // (id, String), sheet name for the exported spreadsheet, (default: 'id')
      });
      table.reset();
      table.getExportData();
    },

    getEduProg() {
      axios({
        method: 'get',
        url: '/programms/get_educational_programms',
      }).then((response) => {
        this.edu_progs = response.data.programs;
      }).catch((error) => {
        return error;
      });
    },

    reset(){
      $('#edu_prog').dropdown('restore defaults');
      this.prog = 0
      this.getInfo(this.prog)
    }

  },
  mounted() {
    this.getInfo(this.prog)
    this.getEduProg()
  }
}
</script>

<style scoped>

</style>